module.exports = __webpack_public_path__ + "img/columnarIcon4.baa92423.svg";